import { render, staticRenderFns } from "./manualHelp.vue?vue&type=template&id=68619c8c&scoped=true"
import script from "./manualHelp.vue?vue&type=script&lang=js"
export * from "./manualHelp.vue?vue&type=script&lang=js"
import style0 from "./manualHelp.vue?vue&type=style&index=0&id=68619c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68619c8c",
  null
  
)

export default component.exports